module.exports = __webpack_public_path__ + "static/media/info.a1d20ea8.svg";